"use client";

import { c as _c } from "react/compiler-runtime";
import { HugeiconsIcon } from "@hugeicons/react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { isNavItemActive, NAVIGATION_ITEMS } from "@/config/navigation";
import { authClient } from "@/lib/auth-client";
import { haptic } from "@/lib/haptics";
import { cn } from "@/lib/utils";
export default function MobileBottomNav() {
  const $ = _c(15);
  const pathname = usePathname();
  const {
    data: session
  } = authClient.useSession();
  const isAuthenticated = Boolean(session?.user);
  if (!isAuthenticated) {
    return null;
  }
  let t0;
  let t1;
  let t2;
  if ($[0] !== isAuthenticated || $[1] !== pathname) {
    let t3;
    if ($[5] !== isAuthenticated) {
      t3 = item => {
        if (item.protected && !isAuthenticated) {
          return false;
        }
        return true;
      };
      $[5] = isAuthenticated;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    const filteredNavItems = NAVIGATION_ITEMS.filter(t3);
    t2 = "fixed right-0 bottom-0 left-0 z-50 md:hidden print:hidden";
    t0 = "safe-area-bottom flex items-center justify-around border-border/40 border-t bg-accent/40 px-2 py-2 backdrop-blur-lg";
    let t4;
    if ($[7] !== pathname) {
      t4 = item_0 => {
        const isActive = isNavItemActive(pathname, item_0);
        return <Link key={item_0.key} href={item_0.href} onPointerDown={() => haptic(isActive ? "tap" : "selection")} className={cn("flex min-w-16 flex-col items-center justify-center gap-1 transition-colors duration-200", isActive ? "text-blue-600 dark:text-blue-400" : "text-muted-foreground hover:text-foreground")}><HugeiconsIcon icon={item_0.icon} className={cn("size-7", isActive && "stroke-[2.5px]")} /><span className="font-medium text-[10px] leading-none">{item_0.label}</span></Link>;
      };
      $[7] = pathname;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t1 = filteredNavItems.map(t4);
    $[0] = isAuthenticated;
    $[1] = pathname;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[9] !== t0 || $[10] !== t1) {
    t3 = <div className={t0}>{t1}</div>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}